import { get } from "lodash"
import { Provider } from "../../../domain/Provider/schema"
import { Practice } from "../../../domain/Practice/schema"
import { ProviderTypeDisplayId } from "../../../domain/enums/displayId.enum"
import { Badge } from "./Badge"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"

const isManagedPractice = (practice?: Practice): boolean => {
  return (
    get(practice, "practiceTypeDisplayId", undefined) ===
    ProviderTypeDisplayId.MANAGED
  )
}

const isManagedProvider = (provider?: Provider): boolean => {
  return (
    get(provider, "providerTypeDisplayId", undefined) ===
    ProviderTypeDisplayId.MANAGED
  )
}

export interface ManagedBadgeProps {
  force?: boolean
  practice?: Practice
  provider?: Provider
}

const ManagedBadge: React.FC<ManagedBadgeProps> = ({
  force = false,
  practice,
  provider,
}: ManagedBadgeProps) => {
  const { cms: cmsContent } = useCMSReady(["common"])
  return force || isManagedPractice(practice) || isManagedProvider(provider) ? (
    <Badge text={cmsContent.common?.managed ?? ""} color="info" />
  ) : (
    <></>
  )
}

export default ManagedBadge
